import React, { FunctionComponent } from "react";
import styles from "./styles.module.scss";
import { PiperDialog } from "../../PiperDialog";

export const AttributeDialog: FunctionComponent<IAttributeDialogProps> = ({
  open,
  onClose,
  children
}) => {
  return (
    <PiperDialog
      className={styles.attributesDialog}
      fullWidth
      maxWidth={"md"}
      open={open}
      onClose={onClose}
      PaperProps={{ style: { height: "100%" } }}
    >
      {children}
    </PiperDialog>
  );
};

export interface IAttributeDialogProps {
  children: React.ReactNode;
  open: boolean;
  onClose: () => void;
}
